import { render, staticRenderFns } from "./ManagersMultiselect.vue?vue&type=template&id=63493e36"
import script from "./ManagersMultiselect.vue?vue&type=script&lang=ts"
export * from "./ManagersMultiselect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63493e36')) {
      api.createRecord('63493e36', component.options)
    } else {
      api.reload('63493e36', component.options)
    }
    module.hot.accept("./ManagersMultiselect.vue?vue&type=template&id=63493e36", function () {
      api.rerender('63493e36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/autocompleteMultiselects/ManagersMultiselect.vue"
export default component.exports